import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices";
import decodeJWT from "../middleware/JWTdecoder"; // Import the decoder function
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";

const apiService = HttpService;

export const fetchUserDetails = createAsyncThunk(
  "auth/fetchUserDetails",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token;
      const response = await apiService.get("/users/details");

      if (!response.data.success) {
        return rejectWithValue(toast.error(response.data.msg));
      }

      console.log("User details is ", response.data);
      //the response data is the user details you want to store
      const userDetailsP = response.data.data[0];
      Cookies.set("userDetails", JSON.stringify(userDetailsP), {
        expires: 7,
        path: "",
      });
      // toast.success('User details fetched successfully');
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.msg);
      return rejectWithValue(
        error.response?.data?.msg || "An error occurred fetching user details"
      );
    }
  }
);
// export const login = createAsyncThunk(
//   'auth/login',
//   async ({ email, password }, { rejectWithValue }) => {
//     try {
//       const response = await apiService.post("/api/web/users/auth", {
//         email,
//         password,
//       });
//       // console.log("Login Response ", response.data);

//       if (!response.data) {
//         return rejectWithValue(toast.error("Enter Correct Credential Or Somthingwent Wrong !!"));
//       }
//       // Decode JWT token here
//       const Token = response.data;
//       // console.log('Decoded Token:', decodedToken);
//       Cookies.set("userDetails", JSON.stringify(Token), {
//         expires: 7,
//         path: "",
//       });
//       toast.success("Succesfully in");
//       // Return both token and decoded data
//       return { token: response.data };
//     } catch (error) {
//       toast.error(error.response?.data?.msg);
//       return rejectWithValue(error.response?.data?.msg || "An error occurred");
//     }
//   }
// );
export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/auth/login", {
        email,
        password,
      });

      if (!response.data) {
        toast.error("Enter Correct Credential Or Something went Wrong!!");
        return rejectWithValue(
          "Enter Correct Credential Or Something went Wrong!!"
        );
      }

      const token = response.data.data.token;
      Cookies.set("userDetails", JSON.stringify(response.data), {
        expires: 7,
        path: "",
      });
      toast.success("Successfully logged in");

      return { token, user: response.data.user }; // Assuming user details are part of response.data
    } catch (error) {
      const errorMessage = error;
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);
export const register = createAsyncThunk(
  "auth/register",
  async (RegisterData, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/public/register", RegisterData);
      return response.data; // response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const getCompanyType = createAsyncThunk(
  "auth/getCompanyType",
  async (companyTypeData, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        "/public/lookups/company-types-register",
        companyTypeData
      );
      return response.data; // response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const getIntegratedPlayerList = createAsyncThunk(
  "auth/getIntegratedPlayerList",
  async (IntegratedPlayerList, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        "/public/lookups/company-access",
        IntegratedPlayerList
      );
      console.log("RESPONSE:", response.data);
      return response.data; // response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const checkCompanyEmail = createAsyncThunk(
  "auth/checkCompanyEmail",
  async (email, { rejectWithValue }) => {
    try {
      // console.log('api called ')
      const response = await apiService.get("/public/register/checkUser", {
        params: { email },
      });
      // console.log('RESPONSE:',response.data)
      return response.data.data; // response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const checkCompanyName = createAsyncThunk(
  "auth/checkCompanyName",
  async (companyName, { rejectWithValue }) => {
    try {
      // console.log('api called ')
      const response = await apiService.get("/public/register/checkCompany", {
        params: { companyName },
      });
      console.log("RESPONSE:", response.data);
      return response.data.data; // response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    userDetails: null, // Store decoded token data
    status: "idle",
    error: null,
    companyType: null,
    existCompanyEmail: null,
    existCompanyName: null,
    checkIPlist: [],
    bannerOpen: false,
  },
  reducers: {
    closeBanner: (state) => {
      state.bannerOpen = false;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {})
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        // Store fetched user details in the state
        // state.token = action.payload.data.token
        state.userDetails = action.payload.data[0]; // Adjust based on your state structure
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        // Handle any errors
        state.error = action.payload;
      })
      .addCase(login.pending, (state) => {
        state.status = "loading";
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.token = action.payload;
        // state.userDetails = action.payload.decodedToken; // Update state with decoded token data
        // state.userType = action.payload.decodedToken.userType; // Store user type
        state.error = null;
        state.bannerOpen = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(register.pending, (state) => {
        state.status = "loading";
      })
      .addCase(register.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.token = action.payload;
        state.register = action.payload;
        state.error = null;
      })
      .addCase(register.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getCompanyType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCompanyType.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.token = action.payload;
        state.companyType = action.payload.data;
        state.error = null;
      })
      .addCase(getCompanyType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(checkCompanyEmail.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkCompanyEmail.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.token = action.payload;
        state.existCompanyEmail = action.payload;
        state.error = null;
      })
      .addCase(checkCompanyEmail.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(checkCompanyName.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkCompanyName.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.token = action.payload;
        state.existCompanyName = action.payload;
        state.error = null;
      })
      .addCase(checkCompanyName.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getIntegratedPlayerList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getIntegratedPlayerList.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.token = action.payload;
        state.checkIPlist = action.payload.data;
        state.error = null;
      })
      .addCase(getIntegratedPlayerList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setToken, closeBanner } = authSlice.actions;
export const selectToken = (state) => state.auth.token;
export const authReducer = authSlice.reducer;
